import { render, staticRenderFns } from "./ImgModalCarousel.vue?vue&type=template&id=5aa04e54&scoped=true"
import script from "./ImgModalCarousel.vue?vue&type=script&lang=js"
export * from "./ImgModalCarousel.vue?vue&type=script&lang=js"
import style0 from "./ImgModalCarousel.vue?vue&type=style&index=0&id=5aa04e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa04e54",
  null
  
)

export default component.exports